<template>
  <div class="resultDistance">
    <h3>{{ $t('resultGui.header') }}</h3>
    <!--     <button @click="calcNow" class="btn btn-primary">Kalk</button> -->
    <!--     <div v-if="calculationResult.mainMessage.active" class="alert" :class="'alert-'+calculationResult.mainMessage.resultType">
            {{result.}}
        </div> -->
    <p v-html="$t('resultGui.description')">

    </p>
    <div v-if="isErrorBecauseWrongBusDevices" class="alert alert-danger d-flex">
      <div class="ps-3">
        <i class="fa-solid fa-thumbs-down fa-3x"></i>
      </div>
      <div class="m-auto px-5">
        {{ $t('resultGui.messages.deviceNotMatch') }}
        <div>
          <button @click="removeNotWorkDevices" class="button button-primary mt-1">
            {{ $t('resultGui.action.removeNotWorkDevices') }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="result.errorMessages.length >= 1" class="alert alert-danger d-flex align-items-center">
      <div class="leftAbsolute ps-3">
        <i class="fa-light fa-circle-xmark fa-3x"></i>
      </div>
      <div class="m-auto ps-5 pe-5">
        <div :key="index" v-for="(message, index) of result.errorMessages">
          {{ message }}
        </div>
      </div>

    </div>
    <div
        v-if="(result.noteMessages.length >= 1) && (result.errorMessages.length == 0) && !isErrorBecauseWrongBusDevices"
        class="alert alert-warning d-flex align-items-center">
      <div class="leftAbsolute pt-2 ps-3">
        <i class="fa-light fa-circle-exclamation fa-3x"></i>
      </div>
      <div class="m-auto ps-5 pe-5">
        {{ $t('resultGui.messages.configurationWork') }}<br>
        <b>{{ $t('resultGui.butConsider') }}:</b>
        <div :key="index" v-for="(message, index) of result.noteMessages">
          {{ message }}
        </div>
      </div>
      <div>

      </div>
    </div>
    <div
        v-if="((result.errorMessages.length == 0) && (result.noteMessages.length == 0) && !isErrorBecauseWrongBusDevices) && resultExists"
        class="alert alert-success m-auto d-flex justify-content-center align-items-center my-2">
      <i class="fa-light fa-circle-check fa-3x"></i>
      {{ $t('resultGui.messages.configurationWork') }}
    </div>

    <div v-if="!resultExists" class="alert alert-secondary">
      <!--         <div class="leftAbsolute">
                  <i class="fa-solid fa-check fa-3x"></i>
              </div> -->
      <div class="m-auto ps-5 pe-5">
        {{ $t('resultGui.messages.noResult') }}
      </div>
    </div>


    <div v-if="result.current >1" class="">
      <div class="pw-grid col-10">
        <!--         <div class="m-auto" v-if="result.powerExtenderIsNeed">
                    <div id="addPowerSupply">
                        <div class="card-header">
                <span class="text-warning">
                            <i class="fa-solid fa-circle-exclamation fa-lg"></i>
                </span>
                <span class="ms-2">
                  {{$t('resultGui.messages.needSecondPowerSupply')}}</span><br>
                        </div>
                        <div class="card-image">
                            <img :src="getImage" />
                        </div>
                        <div class="card-footer">
                            {{getDALIPowerExtender.productNo}} <br>{{$t('products.'+getDALIPowerExtender.productNo+'.name')}}
                        </div>
                    </div>
                </div> -->
        <div class="m-auto col-10" id="resultContainer">
          <div class="rounded">
            <table class="p-1">
              <tbody>
              <tr>
                <th>{{ $t('resultGui.currentConsumption') }}</th>
                <td :class="'text-'+getCurrentConsumptionStyle" class="resultColumn">{{ result.current }} mA</td>
                <td>
                                <span v-if="result.tooManyCurrent">
                                    <span @click="alertInfo($event,
                                    'resultGui.messages.tooHighPowerConsumption.topic', 
                                    'resultGui.messages.tooHighPowerConsumption.description')"
                                          class="text-danger pointer">
                                        <i class="fa-solid fa-circle-exclamation fa-lg"></i>
                                    </span>
                                </span>
                </td>
              </tr>
              <tr>
                <th>{{ $t('resultGui.shortAddresses') }}</th>
                <td :class="'text-'+getShortAddressStyle">{{ result.shortAddress }}</td>
                <td>
                                <span v-if="result.tooManyShortAddress">
                                    <span @click="alertInfo($event,
                                    'resultGui.messages.tooManyShortAddresses.topic', 
                                    'resultGui.messages.tooManyShortAddresses.description')"
                                          class="text-danger pointer">
                                        <i class="fa-solid fa-circle-exclamation fa-lg"></i>
                                    </span>
                                </span>
                </td>
              </tr>
              <tr>
                <th>{{ $t('resultGui.controlGears') }}</th>
                <td :class="'text-'+getControlGearStyle">{{ result.devices.ecg.amount }}</td>
                <td>
                                <span v-if="result.tooManyControlGears">
                                    <span @click="alertInfo($event,
                                        'resultGui.messages.tooManyControlGears.topic', 
                                        'resultGui.messages.tooManyControlGears.description')"
                                          class="text-danger pointer">
                                        <i class="fa-solid fa-circle-exclamation fa-lg"></i>
                                    </span>
                                </span>
                </td>
              </tr>
              <tr>
                <th>{{ $t('resultGui.sensors') }}</th>
                <td :class="'text-'+getSensorStyle">{{ result.devices.sensor.amount }}</td>
                <td>
                                <span v-if="result.tooManySensors">
                                    <span @click="alertInfo(
                                        $event,
                                        'resultGui.messages.tooManySensors.topic', 
                                        'resultGui.messages.tooManySensors.description')"
                                          class="text-danger pointer">
                                        <i class="fa-solid fa-circle-exclamation fa-lg"></i>
                                    </span>
                                </span>
                </td>
              </tr>
              <tr>
                <th>{{ $t('resultGui.inputDevices') }}</th>
                <td>{{ result.devices.input.amount }}</td>
                <td></td>
              </tr>
              <tr>
                <th>{{ $t('resultGui.workload') }}</th>
                <td>{{ result.workload }} %</td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckParticipant from "@/assets/js/checkParticipant"
import {mapGetters} from 'vuex';
import ModalMessageHandler from '@/assets/js/ModalMessageHandler';

export default {
  name: 'ResultOverview',
  emits: ['onChange'],
  data() {
    return {}
  },
  created() {
    this.calcNow()
  },
  updated() {

  },
  methods: {
    alertInfo(event, topic, info) {
      let handler = new ModalMessageHandler(this.$store, event);
      handler.newMessage(topic, info)
    },
    calcNow() {

    },
    removeNotWorkDevices() {
      const checkClass = new CheckParticipant(this.selectedApplicationController);
      let devices = checkClass.removeNotWorkDevices(this.busDevices);
      this.$store.dispatch('busDevice/updateDeviceList', devices)
      this.$emit('onChange')
    }
  },
  computed: {
    ...mapGetters({
      busDevices: 'busDevice/getAllItems',
      allProducts: 'product/getAll',
      controlGearItems: 'busDevice/getControlGearItems',
      inputItems: 'busDevice/getInputItems',
      sensorItems: 'busDevice/getSensorItems',
      selectedApplicationController: 'product/getSelectedApplicationController',
      imagePath: 'app/getImagePath'
    }),
    getCurrentConsumptionStyle() {
      if (this.result.tooManyCurrent) {
        return "danger"
      }
      return "black"
    },
    getShortAddressStyle() {
      if (this.result.tooManyShortAddress) {
        return "danger"
      }
      return "black"
    },
    getControlGearStyle() {
      if (this.result.tooManyControlGears) {
        return "danger"
      }
      return "black"
    },
    getSensorStyle() {
      if (this.result.tooManySensors) {
        return "danger"
      }
      return "black"
    },
    isErrorBecauseWrongBusDevices() {
      const checkClass = new CheckParticipant(this.selectedApplicationController);
      if (!checkClass.isSensorAllowed() && this.busDevices.find(obj => obj.typeCategory == 2)) {
        return true
      }
      if (!checkClass.isInputDeviceAllowed() && this.busDevices.find(obj => obj.typeCategory == 3)) {
        return true
      }
      return false
    },
    getDALIPowerExtender() {
      return this.allProducts.find(obj => obj.productNo == 92846)
    },
    getImage() {
      return this.imagePath + "productImages/" + this.getDALIPowerExtender.productNo + ".png"
      //return "https://www.beg-luxomat.com/uploads/tx_begproducts/jc_medien/web/bilder/produktbild/RGB_JPG_500/"+this.controller.productNo+".jpg"
    },
    resultExists() {
      return this.result.shortAddress > 0 ? true : false
    }

  },
  props: {
    result: Object
  }
}
</script>

<style lang="scss" scoped>
.resultDistance {
  margin-top: 30px;
}

#resultContainer {
  max-width: 400px;
}

.minWidth {
  min-width: 300px;
}

img {
  width: 100%;
}

#addPowerSupply {
  width: 250px;
}

.text-danger {
  color: rgb(132, 32, 41);
}

table {
  border: 2px solid var(--color-primary);
  border-radius: var(--border-radius-default);
}

tr td {
  padding-left: 4rem;
}

.resultColumn {
  min-width: 110px;
}
</style>